import { InjectionToken } from '@angular/core';
import { Environment } from './environment.model';

export const CUSTOMER_APP_ENVIRONMENT = new InjectionToken<Environment>(
  'Environment variable of the app wheere customer'
);
